import CoverageBadge from '../../createAndEdit/components/CoverageBadge';
import { IBudgetItem } from '../../createAndEdit/types';
import { parseDiscountPercent, parseQuantityToNumber } from '../../createAndEdit/utils/budgetCalculations';

interface IDetailServiceMinimizedtemRowProps {
  item: IBudgetItem;
}

const DetailServiceMinimizedtemRow = (props: IDetailServiceMinimizedtemRowProps) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const isRemoved = props.item.removed === true;
  const isCovered = props.item.isCovered === true;

  return (
    <tr className="border-0 !border-b-0 h-[50px]" style={{ borderBottom: 'none' }}>
      <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
        {props.item.ref}
      </td>
      <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {props.item.description}
        </div>
      </td>
      <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {props.item.quantity}
        </div>
      </td>
      <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''} ${isCovered ? 'opacity-60 bg-gray-100' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : isCovered
                ? { padding: '8px', borderRadius: '4px', backgroundColor: '#f3f4f6' }
                : { padding: '8px' }
          }
        >
          {props.item.discount}
        </div>
      </td>
      <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''} ${isCovered ? 'opacity-60 bg-gray-100' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : isCovered
                ? { padding: '8px', borderRadius: '4px', backgroundColor: '#f3f4f6' }
                : { padding: '8px' }
          }
        >
          {formatCurrency(isCovered ? 0 : parseQuantityToNumber(props.item.quantity) * props.item.value * (1 - parseDiscountPercent(props.item.discount) / 100))}
        </div>
      </td>
    </tr>
  );
};

export default DetailServiceMinimizedtemRow;
